"use strict";

var _classCallCheck = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StubErrorService = void 0;

var ErrorService_1 = require("../ErrorService");
/** A blank error service that does nothing. */


var StubErrorService = /*#__PURE__*/function (_ErrorService_1$Error) {
  _inherits(StubErrorService, _ErrorService_1$Error);

  var _super = _createSuper(StubErrorService);

  function StubErrorService() {
    _classCallCheck(this, StubErrorService);

    return _super.apply(this, arguments);
  }

  _createClass(StubErrorService, [{
    key: "clearUserContext",

    /** {@inheritDoc ErrorService.clearUserContext} */
    value: function clearUserContext() {}
    /** {@inheritDoc ErrorService.leaveBreadcrumb} */

  }, {
    key: "leaveBreadcrumb",
    value: function leaveBreadcrumb(message, level, data, category) {}
    /** {@inheritDoc ErrorService.reportError} */
    // eslint-disable-next-line handle-callback-err

  }, {
    key: "reportError",
    value: function reportError(error, context) {}
    /** {@inheritDoc ErrorService.setUserContext} */

  }, {
    key: "setUserContext",
    value: function setUserContext(user) {}
    /** {@inheritDoc ErrorService.sync} */

  }, {
    key: "sync",
    value: function sync() {
      return Promise.resolve();
    }
  }]);

  return StubErrorService;
}(ErrorService_1.ErrorService);

exports.StubErrorService = StubErrorService;